import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const vkMusic: MusicService = {
  id: 'vk-music',
  appId: 'vk',
  name: 'VK Music (VKontakte Music / BOOM)',
  shortName: 'VK Music',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: false,
  color: {
    primary: '#5181b8',
    label: '#5181B8',
    background: '#727982',
  },
  importerID: ImporterID.VK,
  musicAPIID: MusicAPIIntegrationID.VKMusic,
  linkType: 'vkmusic',
  assets: {
    logo: { light: 'vk-light.svg', dark: 'vk-dark.svg' },
    logoPadding: { light: 'vk-light-padding.svg', dark: 'vk-dark-padding.svg' },
    logoColor: { light: 'vk-color-light.svg', dark: 'vk-color-dark.svg' },
    logoColorPadding: {
      light: 'vk-color-light-padding.svg',
      dark: 'vk-color-dark-padding.svg',
    },
    logoOnBackground: 'vk-color-light.svg',
  },
  whatIsDescription: musicServiceMessages.vkMusicWhatIs,
};
